import { render, staticRenderFns } from "./index.vue?vue&type=template&id=529ddaa2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=529ddaa2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529ddaa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('529ddaa2')) {
      api.createRecord('529ddaa2', component.options)
    } else {
      api.reload('529ddaa2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=529ddaa2&scoped=true", function () {
      api.rerender('529ddaa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/NewCrates/index.vue"
export default component.exports